/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/strict-boolean-expressions */

import { FilterConfig, Filter } from '../../types/tape';
import { getFilter } from '../../util/tape';
import useLog from '../useLog';

const useTapeFilters = () => {
  const { fetchAPIWithLog } = useLog('useTapeFilters');

  const fetchSavedFilters = async (
    noSym?: boolean,
  ): Promise<FilterConfig[]> => {
    const response = await fetchAPIWithLog(
      `v1/me/tnsFilters${noSym != null ? `?no_sym=${noSym}` : ''}`,
    );

    if (response.error) {
      throw new Error(
        'Failed to fetch your filters. Try again or contact us if the issue persists.',
      );
    }

    return response.map(getFilter);
  };

  const createNewSavedFilter = async (
    name: string,
    filters: Filter[],
    noSym: boolean,
  ): Promise<FilterConfig> => {
    const response = await fetchAPIWithLog(`v1/me/tnsFilters`, {
      method: 'POST',
      body: JSON.stringify({
        name,
        filter: filters,
        noSym,
      }),
    });

    if (response.error) {
      throw new Error(
        'Failed to create your new filter. Try again or contact us if the issue persists.',
      );
    }

    return response.data[0] && getFilter(response.data[0]);
  };

  const editSavedFilter = async (
    filter: FilterConfig,
  ): Promise<FilterConfig> => {
    const response = await fetchAPIWithLog(`v1/me/tnsFilters/${filter.id}`, {
      method: 'PATCH',
      body: JSON.stringify({
        name: filter.name,
        filter: filter.value,
      }),
    });

    if (response.error) {
      throw new Error(
        'Failed to update your saved filter. Try again or contact us if the issue persists.',
      );
    }

    return response.data[0] && getFilter(response.data[0]);
  };

  const deleteFilter = async (filterId: FilterConfig['id']): Promise<void> => {
    const response = await fetchAPIWithLog(`v1/me/tnsFilters/${filterId}`, {
      method: 'DELETE',
    });

    if (response.error) {
      throw new Error(
        'Failed to delete. Try again or contact us if the issue persists.',
      );
    }
  };

  return {
    fetchSavedFilters,
    createNewSavedFilter,
    editSavedFilter,
    deleteFilter,
  };
};

export default useTapeFilters;
